import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './Termsofservice.css';

const TermsOfService = () => {
  return (
    <div className="term-container">
      <Navbar />
      <div className="terms-of-service-page">
            <h1>Terms of Service</h1>
            <p><strong>Last Updated:</strong> September 7, 2025</p>
            
            <h2>Acceptance of Terms</h2>
            <p>
                By accessing and using LeetEngineer ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. 
                If you do not agree to abide by the above, please do not use this service.
            </p>
            
            <h2>Description of Service</h2>
            <p>
                LeetEngineer is an AI-powered platform that generates tailored technical interview questions, HR screening preparation, and professional resume building based on job postings. 
                The service provides comprehensive career preparation tools for engineering professionals, including instant question generation, answer guides, and custom resume creation from scratch or tailored to specific job requirements.
            </p>
            
            <h2>User Accounts</h2>
            <p>
                To use certain features of the Service, you must register for an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
            </p>
            
            <h2>Acceptable Use</h2>
            <p>You agree not to use the Service to:</p>
            <ul>
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe on the rights of others</li>
                <li>Transmit harmful or malicious code</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Use the Service for any fraudulent or illegal purposes</li>
            </ul>
            
            <h2>Intellectual Property</h2>
            <p>
                The Service and its original content, features, and functionality are and will remain the exclusive property of LeetEngineer and its licensors. 
                The Service is protected by copyright, trademark, and other laws.
            </p>
            
            <h2>AI-Generated Content</h2>
            <p>
                The questions, answers, and resumes generated by our AI are for educational, preparation, and professional development purposes only. 
                We do not guarantee the accuracy or completeness of AI-generated content and recommend users verify information independently and customize content to their specific needs.
            </p>
            
            <h2>Privacy</h2>
            <p>
                Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the Service, to understand our practices.
            </p>
            
            <h2>Payment and Refunds</h2>
            <p>
                Some features of the Service may require payment. All payments are processed securely. 
                We offer refunds within 30 days of purchase for eligible accounts. If you're not satisfied with our service, please contact our support team at support@leetengineerai.com with your account details and reason for the refund request.
            </p>
            
            <h2>Disclaimer of Warranties</h2>
            <p>
                The Service is provided on an "as is" and "as available" basis. We make no representations or warranties of any kind, express or implied, as to the operation of the Service or the information, content, or materials included therein.
            </p>
            
            <h2>Limitation of Liability</h2>
            <p>
                In no event shall LeetEngineer be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the Service.
            </p>
            
            <h2>Termination</h2>
            <p>
                We may terminate or suspend your account and access to the Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
            </p>
            
            <h2>Governing Law</h2>
            <p>
                These Terms shall be interpreted and governed by the laws of the jurisdiction in which LeetEngineer operates, without regard to conflict of law provisions.
            </p>
            
            <h2>Changes to Terms</h2>
            <p>
                We reserve the right to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect.
            </p>
            
            <h2>Contact Information</h2>
            <p>
                If you have any questions about these Terms of Service, please contact us at <a href="mailto:support@leetengineerai.com">support@leetengineerai.com</a>.
            </p>
      </div>
       <Footer />
    </div>
   
  );
};

export default TermsOfService;
